<ng-select
  [items]="recipients"
  bindLabel="displayName"
  [addTag]="true"
  [multiple]="true"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="2"
  [loading]="recipientsLoading"
  typeToSearchText="Please enter 2 or more characters"
  (search)="recipientsInput$.next($event.term)"
  [(ngModel)]="selectedRecipients"
  groupBy="type"
  (add)="addRecipient($event)"
  (remove)="removeRecipient($event)"
  [placeholder]="placeholder"
  (clear)="removeRecipient($event);"
  [readonly]="disabled"
>
<ng-template ng-label-tmp ng-option-tmp let-item="item">
  <div class="px-2" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <topo-avatar [name]="item?.displayName"></topo-avatar>
    <div>
      <div fxLayout="row">
        <div class="has-text-weight-semibold">{{ item?.displayName }}</div>
      </div>
    </div>
  </div>
</ng-template>
</ng-select>
